import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import OpenEye from '../../../../static/images/signup/Openeye.svg';
import CloseEye from '../../../../static/images/signup/closeeye.svg';
import Button from '../../../../ui-core/Button/Button';
import { doOtpRequest, doUpdatePassword } from '../../../../store/action/auth';
import { getItem, removeItem } from '../../../../utils/cache';
import { LOCAL_STORAGE_CONSTANT, MODAL_TYPE } from '../../../../constants/app';
import PropTypes from 'prop-types';
import { extractJSON } from '../../../../services/jsonUtil';
import { APP_ROUTES } from '../../../../route';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ChangePasswordModal = props => {
  const { isLoading } = useSelector(state => state.common);
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const resetEmail = JSON.parse(getItem('resetDetails'))?.email;
  const resetOtp = JSON.parse(getItem('resetDetails'))?.otp;
  const { handleModalState } = props;
  const history = useHistory();

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required('Please enter password.')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d\s]).{8,}$/,
        'Password must be at least 8 characters, contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
      ),
    confirmPassword: Yup.string()
      .required('Please enter confirm password.')
      .oneOf(
        [Yup.ref('password'), null],
        'Password and confirm password must be the same.',
      ),
  });

  const onSubmit = values => {
    const payload = {
      email: resetEmail,
      code: resetOtp,
      password: values?.password,
      password_confirmation: values?.confirmPassword,
    };

    const loginPayload = {
      email: resetEmail,
      password: values.password,
      email_signin: true,
    };
    dispatch(
      doUpdatePassword({
        data: payload,
        callback: () => {
          dispatch(
            doOtpRequest({
              data: loginPayload,
              callback: () => {
                const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
                removeItem('resetDetails');
                if (
                  user?.attributes?.mobile === '' ||
                  user?.attributes?.mobile === null ||
                  user?.attributes?.mobile.includes('@')
                ) {
                  handleModalState(MODAL_TYPE.PHONE);
                } else {
                  const isRedirectCourse = getItem('redirectToCourse');
                  if (isRedirectCourse) {
                    props.handleClose();
                  } else {
                    history.push(APP_ROUTES.HOME);
                  }
                }
              },
              errorCallback: () => {
                handleModalState(MODAL_TYPE.SIGNUP);
              },
            }),
          );
        },
      }),
    );
  };

  const { errors, handleSubmit, setFieldValue, touched } = useFormik({
    validationSchema,
    onSubmit,
    initialValues: {
      password: '',
      confirmPassword: '',
    },
  });
  return (
    <>
      <div className="form-h">
        <h2 className="sign-in-h1">New password</h2>
        <p className="sign-in-h3 mt-4 pb-2">Enter your new password.</p>
        <form onSubmit={handleSubmit}>
          <div className="pass_input mt-4">
            <label htmlFor="password" className="text-uppercase sign_label">
              Enter Password
            </label>
            <div className="mt-2 pass_input_text">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                id="password"
                className="border-0 w-100 sign_up_input"
                placeholder="Enter password"
                onChange={event =>
                  setFieldValue('password', event.target.value)
                }
              />
              <div onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? (
                  <img src={OpenEye} alt="show icon" />
                ) : (
                  <img src={CloseEye} alt="hide icon" />
                )}
              </div>
            </div>
            {!!errors?.password && !!touched?.password && (
              <div className="text-danger error-text">{errors?.password}</div>
            )}
          </div>
          <div className="pass_input mt-4">
            <label
              htmlFor="confirmPassword"
              className="text-uppercase sign_label"
            >
              Confirm password
            </label>
            <div className="mt-2 pass_input_text">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                name="confirmPassword"
                id="confirmPassword"
                className="border-0 w-100 sign_up_input"
                placeholder="Confirm password"
                onChange={event =>
                  setFieldValue('confirmPassword', event.target.value)
                }
              />
              <div onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? (
                  <img src={OpenEye} alt="show icon" />
                ) : (
                  <img src={CloseEye} alt="hide icon" />
                )}
              </div>
            </div>
            {!!errors?.confirmPassword && !!touched?.confirmPassword && (
              <span className="text-danger error-text">
                {errors?.confirmPassword}
              </span>
            )}
          </div>

          <Button
            text="CONTINUE"
            class={`OtpButton ${isLoading && ''}`}
            isLoading={isLoading}
          />
        </form>
      </div>
    </>
  );
};

ChangePasswordModal.propTypes = {
  handleModalState: PropTypes.func,
  handleClose: PropTypes.func,
};

export default ChangePasswordModal;
